import React, { FC } from 'react';

import styles from './popover_wrapper.module.scss';

export const PopoverWrapper: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
